// Modules
import React, { useEffect, useRef, useContext } from "react";
import PropTypes from "prop-types";

// Context
import ApiContext from "../../../contexts/ApiContext";

// Assets
import "./gauge.scss";

const Gauge = (props) => {
	const {
		clssName,
		percent,
		loader,
		text,
	} = props;
	const needleRef = useRef(null);
	const timeout1 = useRef(0);
	const timeout2 = useRef(0);
	const timeout3 = useRef(0);
	const timeout4 = useRef(0);
	const { isMobile } = useContext(ApiContext);

	useEffect(() => {
		let deg = 92;

		if (percent === 5)
			deg = 10;
		else if (percent === 50)
			deg = 92;
		else if (percent === 100)
			deg = 175;

		if (loader === false && needleRef.current !== null) {
			needleRef.current.style.transform = `rotateZ(${deg - 15}deg)`;
			timeout1.current = setTimeout(() => {
				if (needleRef.current !== null)
					needleRef.current.style.transform = `rotateZ(${deg + 15}deg)`;
			}, 250);
			timeout2.current = setTimeout(() => {
				if (needleRef.current !== null)
					needleRef.current.style.transform = `rotateZ(${deg - 5}deg)`;
			}, 500);
			timeout3.current = setTimeout(() => {
				if (needleRef.current !== null)
					needleRef.current.style.transform = `rotateZ(${deg + 5}deg)`;
			}, 750);
			timeout4.current = setTimeout(() => {
				if (needleRef.current !== null)
					needleRef.current.style.transform = `rotateZ(${deg}deg)`;
			}, 1000);
		}
	}, [loader, needleRef, percent]);

	/**
	 * On componentWillUnmount(), we clean all async functions.
	 */
	useEffect(() => {
		return () => {
			clearTimeout(timeout1.current);
			clearTimeout(timeout2.current);
			clearTimeout(timeout3.current);
			clearTimeout(timeout4.current);
		}
	}, []);

	return (
		<div className={`gauge-container ${clssName} ${isMobile === true ? "mobile" : ""}`}>
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				x="0px"
				y="0px"
				viewBox="0 0 440 220"
				className="gauge"
				style={{ enableBackground: "new 0 0 440 220" }}
			>
				<g>
					<path
						className={`quarter ${percent > 5 ? "filled" : ""}`}
						d="M102,122.1C86,111,53.7,88.7,53.7,88.7C31.2,120.6,18,159.4,18,201.7H79c0-1.2-0.1-2.6-0.1-3.8 C78.9,169.9,87.5,143.9,102,122.1z"
					/>
					<path
						className={`quarter ${percent >= 17 ? "filled" : ""}`}
						d="M142.2,82.5c-4.1-7.5-8.5-14.8-12.8-22.2c-4.7-8.1-9.3-16.1-13.8-24.2c-0.5-1-1.1-2.1-1.7-3.1 C90.1,47.3,69.7,66.2,53.7,88.7v0c15.9,11.5,31.8,22.3,48.3,33.4C112.4,106.4,126.1,92.9,142.2,82.5z"
					/>
					<path
						className={`quarter ${percent >= 34 ? "filled" : ""}`}
						d="M129.4,60.3c4.3,7.3,8.4,14.8,12.8,22.2C164.2,68.3,190.6,60,218.9,60V4.7C180.9,4.8,144.1,15.1,114,33.1 c0.5,1,1.1,2.1,1.7,3.1C120.1,44.3,124.7,52.3,129.4,60.3z"
					/>
					<path
						className={`quarter ${percent >= 51 ? "filled" : ""}`}
						d="M291.1,79.8c9.3-16.2,17.9-32.7,26.7-49.2c-28.8-16.2-63.6-25.5-99.2-25.9V60C245.2,60,270.1,67.3,291.1,79.8z"
					/>
					<path
						className={`quarter ${percent >= 68 ? "filled" : ""}`}
						d="M291.1,79.8c20,11.9,36.7,28.7,48.5,48.6c17.7-7.8,35.5-15.3,52.9-23.2c-17.5-31.2-43.4-57-74.6-74.6l0,0l0,0 C309,47,300.4,63.6,291.1,79.8z"
					/>
					<path
						className={`quarter ${percent >= 85 ? "filled" : ""}`}
						d="M416.7,181.6c-2.8-27.7-11.2-53.6-24.2-76.4c-17.5,7.9-35.1,15.3-52.9,23.2c12,20.4,19,44.2,19,69.5 c0,1.2,0,2.6-0.1,3.8h57h2.2C417.7,195,417.3,188.3,416.7,181.6z"
					/>
					<path
						className={`needle ${loader === true ? "computing" : ""}`}
						ref={needleRef}
						d="M203,172.6L88.4,190.3l-0.1,0l-58.8,9.3l-1.1,0.1l-9.6,1.5l-1.8,0.3l11.3,1l1.2,0.1l59,5.1l0.3,0l108.8,9.5 l7.1,0.6c2.6,0.2,5.4,0.4,8.2,0.4c1.7-0.1,3.3-0.2,5-0.5c13.7-2.3,24-12.2,23.6-23.7l0.1,0c-0.4-12.8-13.9-22.8-30.1-22.3 C208.6,171.9,205.5,172.1,203,172.6z"
					/>
				</g>
			</svg>
			<p className="action-to-realise">{text}</p>
		</div>
	);
};

Gauge.propTypes = {
	clssName: PropTypes.string,
	percent: PropTypes.number,
	loader: PropTypes.bool.isRequired,
	text: PropTypes.string,
};

Gauge.defaultProps = {
	clssName: "",
	percent: 50,
	text: "Calcul en cours...",
};

export default Gauge;
